// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"552":"Chatbot","8362":"Modal","9156":"MobileLandscape"}[chunkId] + ".chunk.min.css";
};